exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filters[data-v-6235f944] { margin-bottom: 4px;\n}\n.alert[data-v-6235f944] { margin-bottom: 16px;\n}\n.danger-text[data-v-6235f944] { color: #f56c6c;\n}\n", ""]);

// exports
